var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00008 0.333984C4.53322 0.333984 3.33341 1.53379 3.33341 3.00065V4.33398H2.16675C1.34425 4.33398 0.666748 5.01148 0.666748 5.83398V12.1673C0.666748 12.9898 1.34425 13.6673 2.16675 13.6673H9.83342C10.6559 13.6673 11.3334 12.9898 11.3334 12.1673V5.83398C11.3334 5.01148 10.6559 4.33398 9.83342 4.33398H8.66675V3.00065C8.66675 1.53379 7.46694 0.333984 6.00008 0.333984ZM6.00008 1.33398C6.92655 1.33398 7.66675 2.07418 7.66675 3.00065V4.33398H4.33341V3.00065C4.33341 2.07418 5.07361 1.33398 6.00008 1.33398ZM2.16675 5.33398H9.83342C10.1156 5.33398 10.3334 5.55182 10.3334 5.83398V12.1673C10.3334 12.4495 10.1156 12.6673 9.83342 12.6673H2.16675C1.88458 12.6673 1.66675 12.4495 1.66675 12.1673V5.83398C1.66675 5.55182 1.88458 5.33398 2.16675 5.33398ZM6.00008 8.00065C5.73487 8.00065 5.48051 8.10601 5.29297 8.29354C5.10544 8.48108 5.00008 8.73543 5.00008 9.00065C5.00008 9.26587 5.10544 9.52022 5.29297 9.70776C5.48051 9.89529 5.73487 10.0007 6.00008 10.0007C6.2653 10.0007 6.51965 9.89529 6.70719 9.70776C6.89472 9.52022 7.00008 9.26587 7.00008 9.00065C7.00008 8.73543 6.89472 8.48108 6.70719 8.29354C6.51965 8.10601 6.2653 8.00065 6.00008 8.00065Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.c3020732392f864809b82aed67021df0.svg";
export { ForwardRef as ReactComponent };